import axios from "axios";


//pass new generated access token here


//apply base url for axios
const API_URL = "https://testrsapi.realtyspacehub.com/api/";
//const API_URL = "https://rscoreapi.azurewebsites.net/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
   headers: {
    "Content-Type": "application/json",
    //"Access-Control-Allow-Origin": "*",
  },
});

// Request interceptor to handle CORS and add credentials per request
axiosApi.interceptors.request.use(
  (config) => {
    // Ensure withCredentials is set if not explicitly disabled
    if (config.withCredentials === undefined) {
      config.withCredentials = true;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor with better error handling for CORS
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle CORS errors specifically
    if (!error.response && error.message === 'Network Error') {
      console.error('CORS Error: The request was blocked. Please ensure:');
      console.error('1. The server allows CORS from your origin');
      console.error('2. The server sets Access-Control-Allow-Credentials: true');
      console.error('3. The server sets Access-Control-Allow-Origin to your specific origin (not *)');
      console.error('4. The server handles preflight OPTIONS requests');
    }
    return Promise.reject(error);
  }
);

// The get/post/put/del convenience wrappers used to live here. They now live in
// ./http_helper, built on this same configured instance — import them from there.
export default axiosApi;
